import fonts from 'google-fonts-complete'


const randomKey = function (obj) {
  var keys = Object.keys(obj);
  return keys[ keys.length * Math.random() << 0];
};

/* eslint-disable no-undef */
function getRandomPair(callback) {
  let fontA = randomKey(fonts);
  let fontB = randomKey(fonts);

  while(fontA === fontB) {
    fontB = randomKey(fonts);
  }

  const fontObj = {
    primaryName: fontA,
    secondaryName: fontB
  }

  return fontObj;
}

const FontsAPI = {
  getRandomPair,
};
export default FontsAPI;



// WEBPACK FOOTER //
// ./src/api/FontsAPI.js